
import React from "react";
import styles from "./styles.css";
import LogoCard from "../../shared/logo-card";
import PropTypes from "prop-types";
import { STEP_NAMES } from "../../../constants/app-constants";
import { trackMobileEvent } from "../../../tracking";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
// import trackSellOnlineEvents from "../../../utils/helpers/sell-online-mmyvs-ga-events";

const PopularBrands = ({
    popularBrands,
    nextStep = () => { },
    setData = () => { },
    selected,
    // applicableCityForSellOnline,
    callback = () => { },
    isRevamped = false
}) => {
    const onClickHandler = async (selectedBrand, e) => {
        await yieldToMain();

        setData({ type: STEP_NAMES.Brand, data: selectedBrand });
        callback(selectedBrand);
        nextStep();
        window.requestAnimationFrame(() => {
            trackMobileEvent({
                category: "brandSelectionScreen",
                key: "brand",
                e
            });
        });
        // trackSellOnlineEvents(STEP_NAMES.Brand, applicableCityForSellOnline);
    };

    return (
        <div styleName={`styles.setContent ${isRevamped ? "styles.isRevampedLogo" : ""}`}>
            <ul className={"row"}>
                {popularBrands.map(brand => (
                    <li key={brand.id}
                        data-title={brand.displayName}
                        onClick={(e) => onClickHandler({
                            displayText: brand.displayName,
                            id: brand.id,
                            make_display: brand.make_display
                        }, e)}
                        className={"col-4 shrinkOnTouch"}
                    >
                        <LogoCard
                            altText={brand.displayName}
                            image={brand.logo}
                            selected={selected === brand.id}
                        />
                    </li >
                ))}
            </ul>
        </div>
    );
};

PopularBrands.propTypes = {
    popularBrands: PropTypes.array.isRequired,
    nextStep: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    selected: PropTypes.number.isRequired,
    // applicableCityForSellOnline: PropTypes.array,
    callback: PropTypes.func,
    isRevamped: PropTypes.bool
};

export default PopularBrands;
